import { FormControl, SelectChangeEvent } from '@mui/material';
import PaginationItem from '@mui/material/PaginationItem';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TacticPaginationCountStyle,
  TacticPaginationResultStyle,
  TacticPaginationStyle,
  TacticPaginationWrapperStyle,
  TacticSelectStyle,
} from './TacticKanbanPagination.styles';
import { PAGINATION_PAGE_SIZE_STEPS } from 'basics/constants/common.constant';
import ArrowLeftIcon from 'components/Icons/ArrowLeftIcon';
import ArrowRightIcon from 'components/Icons/ArrowRightIcon';
import Box from 'yoda-ui/components/Box';
import Select from 'yoda-ui/components/Form/Select';
import MenuItem from 'yoda-ui/components/MenuItem';
import Pagination from 'yoda-ui/components/Pagination';
import { YodaFontSize } from 'yoda-ui/yodaTheme';

type TacticKanbanPaginationProps = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: SelectChangeEvent<unknown>) => void;
};

const TacticKanbanPagination: FC<TacticKanbanPaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const { t } = useTranslation();
  const pageCount = Math.ceil(count / rowsPerPage);
  const paginationResultCountLabel = t('maya_list_pagination_result_count_label',
    { displayedCount: rowsPerPage * (page + 1) > count ? count % rowsPerPage : rowsPerPage, rowsCount: count });

  return (
    <Box sx={ TacticPaginationWrapperStyle }>
      <FormControl sx={ TacticPaginationStyle }>
        <Select
          value={ rowsPerPage }
          onChange={ onRowsPerPageChange }
          sx={ TacticSelectStyle }
        >
          {
            PAGINATION_PAGE_SIZE_STEPS.map(
              (pageSizeStep: number) => {
                return <MenuItem key={ pageSizeStep }
                  value={ pageSizeStep }>{ pageSizeStep }</MenuItem>;
              },
            )
          }

        </Select>
      </FormControl>
      <Box sx={ TacticPaginationResultStyle } fontSize={ YodaFontSize.small }>{ paginationResultCountLabel }</Box>
      <Pagination
        sx={ TacticPaginationCountStyle }
        count={ pageCount }
        page={ page + 1 }
        size="small"
        onChange={ onPageChange }
        renderItem={
          (item) => (
            <PaginationItem
              { ...item }
              components={
                {
                  previous: ArrowLeftIcon,
                  next: ArrowRightIcon,
                }
              }
            />
          )
        }
      />
    </Box>
  );
};

export default TacticKanbanPagination;
